import styled from "styled-components";
import { COLOUR_CONSTANT } from "../../../../utils/contants";

export const UserTableStyled = styled.div`
  .project-table {
    padding-top: 40px;
  }
  .table-wrapper {
    margin: 0 !important;
    .MuiPaper-root {
      height: calc(100vh - 200px);
      overflow-y: auto;
    }
  }
  tr {
    background-color: white !important;
  }

  .user-table {
    padding: 12px 36px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    thead {
      tr {
        & th:nth-child(1) {
          position: sticky !important;
          left: 0;
          opacity: 1;
          z-index: 3;
        }
        & th:nth-child(2) {
          position: sticky !important;
          left: 80px;
          opacity: 1;
          z-index: 3;
        }
      }
    }
    tbody {
      tr {
        & td:nth-child(1) {
          position: sticky !important;
          left: 0;
          z-index: 2;
          opacity: 1;
          background-color: ${COLOUR_CONSTANT.theme.purple.light};
        }

        & td:nth-child(2) {
          position: sticky !important;
          left: 80px;
          z-index: 2;
          opacity: 1;
          background-color: ${COLOUR_CONSTANT.theme.purple.light};
        }
      }
    }
  }
  .action-menu .def-background {
    background-color: white;
    border: none;
  }
`;
